import { defineScreen } from "@vjal/screen-kit";
import { ProductRouteScreenAdapter } from "../pages/product-route-context";

/** ScreenModule IR authority — Component is the shared product route adapter. */

export const clear_seriesScreenModule = defineScreen({
  app: "coaching",
  screen_id: "clear-series",
  path: "/cohorts/:cohort_id/sessions/clear",
  params: ["cohort_id"],
  heading: { text: "Clear session series", level: 1 },
  roles: {
    "super_admin": "allow",
    "admin": "deny",
    "coach": "allow",
    "company_admin": "deny",
    "participant": "deny",
    "cohort_lead": "deny"
  },
  states: ["ready"],
  actions: [
    { id: "load", kind: "secondary", driver: "page.load" }
  ],
  recipe: "Page-1",
  data: { seedNeeds: ["readonly-walk-session"] },
  authority: { source_ref: "apps/coaching-dashboard/src/screens/clear-series.tsx" },
  Component: ProductRouteScreenAdapter,
});

export default clear_seriesScreenModule;
